import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'WorldLayout25',
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: '1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2',
      type: 'Container',
      name: 'backgrounds',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '3',
      type: 'Container',
      name: 'nodesContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '4',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map_25_export_1',
      parent: '2',
      data: ''
    },
    {
      id: '7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1350,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map_25_export_2',
      parent: '2',
      data: ''
    },
    {
      id: '8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2700,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map_25_export_3',
      parent: '2',
      data: ''
    },
    {
      id: '10',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5400,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map_25_export_5',
      parent: '2',
      data: ''
    },
    {
      id: '9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4050,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map_25_export_4',
      parent: '2',
      data: ''
    },
    {
      id: '9f0cb310-b23d-4e3f-b2a4-8ab9baf4013b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6750,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map_25_export_6',
      parent: '2',
      data: ''
    },
    {
      id: '12',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8100,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map_25_export_7',
      parent: '2',
      data: ''
    },
    {
      id: '13',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9450,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map_25_export_8',
      parent: '2',
      data: ''
    },
    {
      id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 395,
      y: 436,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '84e8fadc-7800-4a15-91a7-cf6c15f3f128',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 506,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8f5a8515-78b9-40e8-ac1c-eb34ba763598',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 616,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '551f3d5c-7a40-4001-be7a-e4deeff42ffd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 724,
      y: 419,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '52b52ac2-84bb-4b37-b1b8-545f37ec279a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 789,
      y: 498,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '51d8b097-7ea7-4b99-940e-5e6200266c3f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 853,
      y: 574,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '91a0553b-3ea2-417d-8838-07bda5aef54e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 956,
      y: 576,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '083fe7a5-79b2-4c7f-b16c-e6995791d293',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1051,
      y: 532,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c37dadea-0f4a-4ceb-9e87-a53bf17ba307',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1125,
      y: 461,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '95361899-9b1b-4ce1-a437-6210c9c27fc3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1197,
      y: 392,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e97447d5-b7ed-44bb-99fd-9020d86cc6dd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1271,
      y: 329,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '24cf05d0-dfc6-40de-8367-53f77b474fa0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1360,
      y: 281,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6cc07922-f0b4-404b-b651-f4276645b01f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1458,
      y: 254,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd6f3e99d-95cf-4d97-b898-8a1da233c47e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1558,
      y: 247,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '99e19204-e611-49d7-84dc-3e05cc9ac6a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1648,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b79cc4ac-48ea-4ea8-a65a-e3169e811a76',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1716,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '89cfc4f4-990a-4bca-80d1-16c5b54238a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1773,
      y: 442,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b6414e5b-a119-4889-b5fd-789f40339a0c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1839,
      y: 514,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a99fbe26-a59c-456e-8d8d-200fad7559e8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1925,
      y: 566,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '455f902f-d7b6-4b2c-a2c7-257b2b043275',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2024,
      y: 590,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e71fd146-3bb6-4e86-b1a2-47f51d71e20f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2122,
      y: 557,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '85220bdc-2f8f-4d75-a9da-bd9ecc865db3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2200,
      y: 499,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '92587773-3a26-4e7f-8ab4-ef72d5e57902',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2288,
      y: 456,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5edd529e-a320-4d71-93d8-9b142eca9079',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2387,
      y: 429,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0f314672-410c-496f-b1f9-28589474bff5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2481,
      y: 393,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2a2b3996-2e96-407e-b584-38e6fd4c8b84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2572,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bbb65545-1b86-4fc0-b902-977d78cdce96',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2667,
      y: 314,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f8ce312c-2aa0-45a8-8668-b101d4be7d7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2754,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e7a46c57-8c10-4761-a491-e9edf65d613f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2835,
      y: 206,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f3e123f7-e400-4bff-8c8a-940e71f55823',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2930,
      y: 172,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1646795a-6143-4eae-bc3d-a167f0c1f627',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3029,
      y: 159,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bc49d8a2-7da0-437b-a1ff-eb1e6fde8fe6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3128,
      y: 182,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '59f2fdc2-3ade-4498-9a8f-3d9a35b79947',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3205,
      y: 240,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b701b441-170b-4ad3-8bfc-c2d1d644262a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3252,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7769ff26-41e0-49e5-84ac-114871c12e9c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3274,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '56858f3f-67dc-4743-8e44-948af0cbf772',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3297,
      y: 492,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1969aab1-97a8-4429-a434-fca05ea3a541',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3354,
      y: 565,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a117b47a-d6b2-4b45-b9ea-fe12418647bf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3438,
      y: 611,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '407974ca-1c24-41fd-90de-1df8b04ab6b6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3538,
      y: 616,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd8538321-2750-46cf-b647-c0e9f0e4be82',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3631,
      y: 581,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f2e8233e-0ebc-415f-a983-89372e4fab40',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3685,
      y: 507,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9e45bbfb-1bfb-4d0e-825b-2a233b5469f3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3717,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '79e5f5d9-ac9f-4f2e-aa7c-6b88e3507430',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3801,
      y: 371,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3f3dea4d-02d2-465a-9a7e-bfe622113461',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3905,
      y: 368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3b75f9de-1910-4788-9cd7-8f20668afd4d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4002,
      y: 332,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cfd8d310-ecfb-4b4a-b035-d2544cadc3ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4082,
      y: 269,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '90a07f7a-19bd-4f40-9301-1048dd4bd1fb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4173,
      y: 225,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'eb49fed5-8dd4-41b8-90e7-143636ed5d23',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4276,
      y: 219,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '931d4cd2-e8d7-4180-9464-b21e74e295a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4378,
      y: 239,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e1a37bdd-e97e-4f25-be36-48fa8084875e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4473,
      y: 279,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '485051c1-06e5-4eb8-8676-82c6c0d1a409',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4564,
      y: 325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '06f28747-882a-438f-8f94-554bc877c2ff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4651,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8be835cb-0d45-4b55-92cb-0c33e30dbe43',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4735,
      y: 437,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd84b3f83-578c-40f3-bf6f-92e7bc262cc8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4818,
      y: 494,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '165f9a99-6f11-4382-9725-2332bc521625',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4915,
      y: 531,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b7a1c119-9ef6-46bd-8459-2fbd925fd3b3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5021,
      y: 538,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7ed4d046-2876-4868-9915-2c38a5ac73a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5126,
      y: 526,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a7cb7d5a-9562-4639-96d3-bc5c03de64d0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5213,
      y: 478,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1375bb98-d97d-4549-9674-6897848da150',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5277,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd3a20c23-1ad1-4c17-83dd-cf0fb36077f3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5342,
      y: 332,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '513527ca-5c83-45cd-8d65-2a1ec2ca33f5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5411,
      y: 270,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2519440a-afd8-4556-af0e-5f8e506f2430',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5510,
      y: 228,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'aa626310-59fa-429c-bc82-cf5d73bf868a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5613,
      y: 215,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'da276fc9-e80b-47a8-841e-e675fac0df70',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5713,
      y: 241,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7b6b6b36-0cfa-471a-a97c-b0014226ddf3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5780,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ecdf2382-4555-4659-8859-a3fa7986bc94',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5840,
      y: 395,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '91b4270a-864b-4b88-bea9-dd232c7a01f5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5922,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e03b5ec3-c4f7-4640-b602-8f9a901243d6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6017,
      y: 502,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c343da76-1c76-433b-b4ef-0b2cafd7bc7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6124,
      y: 495,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b0ecb894-6041-4fa1-a748-9178a2bdfae7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6228,
      y: 470,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6093fc8b-9ff1-4aaf-a667-00b2b03a84cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6329,
      y: 501,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '47550300-3435-4ade-8db8-2ea054331e4d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6417,
      y: 556,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '31b99e6f-a56a-4e72-b05e-c7567e92d178',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6528,
      y: 565,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a9127aea-59ef-4459-b544-f8f699a663ac',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6612,
      y: 503,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '45731d30-6cc0-46ba-9c22-b1efa5844eb0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6677,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b79ea704-06cd-4deb-829b-9368eef1f50e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6781,
      y: 357,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd4e8a121-108e-4bb5-98ee-02c93dbb927c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6897,
      y: 323,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9825b7c9-5ef5-47c9-943b-ec9b622bffb7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6979,
      y: 255,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5970a7bd-82a5-4a8e-8446-67368e706276',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7062,
      y: 179,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9719c07f-38d4-4f25-8831-bc55cc2442d0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7171,
      y: 159,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ad704c11-e491-4786-83a2-088aedc1f657',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7280,
      y: 178,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a56b3b33-aea8-4d5e-8b8d-9e64fa9e39b1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7375,
      y: 229,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2a02abef-0c7c-4522-a833-33ab4298368e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7434,
      y: 306,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '22736dc5-89ba-42cc-a228-6ea80ab870ec',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7505,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '328088f6-d380-4828-8ffb-59fee4eab57b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7596,
      y: 414,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '80f9dd02-ba00-463e-a7ba-97cd9883ddfe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7682,
      y: 466,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2f2077f0-9d34-4844-bf2b-81b9272489db',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7751,
      y: 536,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c8a788d7-d8e0-4e19-8dd5-22de3c8059e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7838,
      y: 586,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1715f4c5-e6cc-446e-9008-bcb81f26233d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7942,
      y: 580,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0a57dd60-39b5-41b0-94de-4fddda4a9415',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8042,
      y: 553,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b5a12329-5081-47ec-b00a-27660a6e46e8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8123,
      y: 483,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'dd8f049b-e94d-4eb6-95ab-906f37ac5e61',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8185,
      y: 394,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5c89b898-676b-4e1b-9795-5da3f32e8256',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8285,
      y: 345,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a206d8aa-92f9-4ced-9714-a5933db844aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8381,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ccbdcd37-bc73-4432-8995-0e3aca63f045',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8456,
      y: 223,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7f799afe-4917-470f-af87-6a4f128fa311',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8539,
      y: 151,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '78f56d1f-b170-4a71-9c04-0c4c475db6aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8667,
      y: 138,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c9759cca-d2be-46d1-9cdd-9b53c83adbd3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8773,
      y: 190,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '25e10329-8723-4b80-831a-3e9409a9837e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8811,
      y: 286,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '147fd976-4fcd-4577-b36f-52942dd97950',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8852,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e32bc431-e1b5-4405-a5c0-5fe590ab8c33',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8963,
      y: 410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '149665d8-adc3-4d3e-a763-1727c51addcc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9080,
      y: 419,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '586dfed6-083e-4f12-9eb1-9769bebc9556',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9176,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '10e435e6-e325-4768-bd10-5a99725d417e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9233,
      y: 544,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2e3c5465-b965-4022-a640-4133e2813209',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9320,
      y: 600,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e334603a-4141-4974-9174-66f1aeb6a838',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9415,
      y: 548,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd30985dd-6864-46b9-9558-9656a1728553',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9449,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'dff0bd34-1e25-4d58-b8d3-d7d391101a81',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9483,
      y: 364,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '10390334-2eb6-474f-8c49-ce4390a4087f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9535,
      y: 284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '38aea08e-9dc9-4aca-aca3-ea66859d309d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9607,
      y: 217,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0c5920d1-9f70-427d-bb48-d32f0a61c4ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9707,
      y: 187,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ec6e81ed-cf97-4445-8ccb-cb3e27d561b8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9810,
      y: 203,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4a828dbd-3798-4b80-919d-170f70bff657',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9916,
      y: 225,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '544c199d-077e-4b8f-b1f9-ae7a6c29cbf7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10006,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1353a076-de3d-4935-bb16-0e949425a061',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10043,
      y: 361,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '209a7986-ed11-476e-bff3-a7014b42f492',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10085,
      y: 443,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '25b4376d-8510-4879-8ad0-40cd2640fc04',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10158,
      y: 507,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1e225042-4e4d-4bef-b4be-165d501eeeee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10258,
      y: 533,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2d321a40-fa08-4a6d-8a2b-c5f0024572bf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10363,
      y: 532,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '609963f4-ff10-4b10-9099-8e0bdab96b24',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10460,
      y: 503,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '110',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '164',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '185',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '214',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '219',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '224',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '1b355a2e-d409-489c-8af4-a150c082b42b',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '106',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '160',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '181',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '210',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '215',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '220',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '225',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '230',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'a75fe524-8e1d-4935-b206-17a7c35bc961',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 533,
      y: 85,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '53e39f80-c101-4f92-a533-f1d0c9208488',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 666,
      y: 97,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '6e45dce0-f71b-4e43-aa9e-6be542ace57a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 694,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '838b34ac-d221-4717-9edc-9c978456fb76',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 801,
      y: 59,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '2f0f3f94-8a61-4e3c-8ea8-1f7149503537',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 831,
      y: 182,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '5e02f05c-15df-4b19-8079-c4e79ff036fa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 942,
      y: 109,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '1c6da2b0-5aff-4fc7-9578-209f395b5dbb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1073,
      y: 65,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '150f2e57-cf6f-4540-a88a-b7fcdea4b2b8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 890,
      y: 291,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: 'bc784158-5cb4-43e1-9e4e-f526ee898658',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 592,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '631a8d39-8433-4f87-aeb2-7cf8cad2cfe6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 449,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '769893b3-844e-4d2c-ab02-7841d94d9dc5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 703,
      y: 762,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '4c97e6f8-f08e-43e2-a320-e33298111838',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 567,
      y: 818,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '88ae6a6e-ca58-46a0-9b32-dd44264e7307',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 806,
      y: 850,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd13ff1d6-867c-4294-ab0b-4c3bd29fc97f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 349,
      y: 840,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '0e6bfdee-89a1-45bf-a9bf-113e448de0f0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1007,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fa88eade-d01c-4477-b072-a84a5b24fd34',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1146,
      y: 174,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '13b99282-d625-4e78-9e13-2835322ccc32',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1223,
      y: 80,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f723353b-51f1-4cea-b3df-d2df5c8488d2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1361,
      y: 76,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '74',
      data: ''
    },
    {
      id: '77d72e75-1448-4dda-94f1-ba3010d98cfa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2178,
      y: 92,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '70ef553a-ef9b-4eff-ab03-fb2c22e88fb1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1894,
      y: 149,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '0a2c0f15-d316-4f16-8218-e2d43967c167',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2102,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b5493beb-086e-4c09-b243-8e9213d41a16',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2345,
      y: 58,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '148ba63f-26f6-4eaa-847b-63f513d68eeb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2581,
      y: 139,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '07c2184e-8a86-4281-aef3-99647a200745',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2493,
      y: 50,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '24a7d55c-8b51-42ac-b544-43c562f6c3ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2019,
      y: 100,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '43142d3d-91d2-46c2-bc9a-c270616cb52c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1980,
      y: 246,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: 'fbb7bb88-e7f0-4212-b7f9-331eae4b81fa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1838,
      y: 264,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '15904eb7-5cf3-467c-95bd-21908acc077d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2207,
      y: 278,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '54073aad-c211-473e-b309-7ad1d1f4e647',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2276,
      y: 171,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '6de0ed85-531f-4ec1-851e-8454d1ee9f26',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2449,
      y: 181,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '7685b552-a6b8-41d8-9adb-0133cd4786b7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2685,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '40758e27-f94e-45bc-9d29-5b540df558c9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2365,
      y: 284,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '2a3e6df7-8feb-4af0-975a-51709246ffed',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1069,
      y: 811,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '68142d38-c9db-4fe7-a1df-cf95ab1c5e9a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1200,
      y: 760,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '8d1ebac0-8fd8-45de-a82b-12a785ad1729',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1285,
      y: 649,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '2acdc03a-d77a-4849-8187-1fe490f1c63f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1439,
      y: 615,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '952e817f-364a-42d3-82be-89e905dadadf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1391,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: 'db211f66-8693-4629-8d61-3e24fde47718',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1575,
      y: 645,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: 'd4c485be-ad74-4bbe-bdf7-c41dafe503b3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1670,
      y: 737,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: 'd0903c86-1e09-4d9f-88d6-3524eafa8b56',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1816,
      y: 798,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: 'cd257ef2-843f-43b2-bcb3-376d9f10919a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1526,
      y: 760,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: 'dc3ff646-75fc-472f-9f22-9f4140f61421',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1636,
      y: 861,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '4b9e32c6-4cb9-4233-8fe2-451e9d22bd55',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1326,
      y: 841,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_4',
      parent: '110',
      data: ''
    },
    {
      id: '7613867a-efe7-4e75-93fb-369ac14b471d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2556,
      y: 775,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'd60cc5c0-db42-4953-8575-9f001862e2ed',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2643,
      y: 682,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '362aeec4-dec4-4cbc-9df1-4f2e7d0309ed',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2768,
      y: 621,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '68077a4f-d93d-451d-8977-21fa6c44d986',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2911,
      y: 587,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '53218e28-e89a-4497-8bb5-4df132e5546f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3053,
      y: 571,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '1b214421-d53e-4f69-b0cd-b0bc3cf4aacc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3262,
      y: 118,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'dbf4d27b-b5f3-4917-af77-53fd77d301e3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3371,
      y: 32,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'b278e8ff-6693-4766-9340-1507029d9f0d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3406,
      y: 278,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '1795fb53-cd90-430a-bfb9-dcb6a51f0895',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3562,
      y: 299,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'f67273b8-9381-406c-9bc0-968b22379668',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3691,
      y: 243,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '90029be4-bc72-4ce3-993a-9d2908fc2022',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3817,
      y: 182,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '9284b1c8-a7eb-4b83-aaac-74d413cc89db',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3833,
      y: 58,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '7e3a7617-6456-4bc1-84e8-63a71774d1a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3554,
      y: 169,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '1d4acd8e-baba-4731-bb95-5f33fb4e1c0f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3679,
      y: 112,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '6b3e5758-f5be-420e-a3db-bb0527eab54d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3410,
      y: 149,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '08142080-552c-440f-b14b-c4ce80366ecd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3511,
      y: 52,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'cc36d98a-714e-46b2-98b7-2bf1d1ec9faf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2737,
      y: 775,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'f6ff9580-01cb-484a-97c1-cce23bd7e3f7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2872,
      y: 720,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'e2464f24-3909-4e67-b884-a13da13a12b8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3013,
      y: 696,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '47a02633-d5ea-4121-969b-ec48b66d8b9a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3156,
      y: 680,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'f5b2a27e-a884-4777-87f2-983ffcec3b84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3244,
      y: 787,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '20b7bcfc-1dba-4a23-a8b7-3a1054e26104',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3089,
      y: 810,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: 'bbaad227-e3f8-48fe-ac96-0e9af0f58539',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2930,
      y: 836,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '164',
      data: ''
    },
    {
      id: '9a00d059-aeed-4edc-8708-f6ba2b733a30',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3872,
      y: 765,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: 'bfc858cf-ccd2-4596-bc23-a2cc154309cc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3966,
      y: 677,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '38d08d8d-9a12-4b37-8f52-85faaf88163d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4230,
      y: 567,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '7d59a221-6108-4859-9619-0739f79baab1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4366,
      y: 516,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '0271e1b4-5f72-4a7b-88ab-59134e7deadc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4514,
      y: 548,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e431f90a-c600-4382-913e-5f4a43004dd3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4395,
      y: 635,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '26fcd006-4637-4dc2-9df3-6196e9ebd7fc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4255,
      y: 685,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '233fc1d1-04c7-4743-ad5b-256939c75cb8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4199,
      y: 824,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '475a3d8d-b29d-402d-bbb5-07f105958268',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4346,
      y: 788,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '6752ca15-dd43-4733-a22e-4b406f70c40d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4482,
      y: 737,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '9b4a795f-f794-4069-a6dd-0b3e87d11284',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4589,
      y: 647,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: 'c7a78339-a79b-41db-84ae-63642f458f4d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4727,
      y: 683,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '705d4ce0-f34a-49eb-aa70-2a56e37ab838',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4629,
      y: 772,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '83ac72b5-0cd4-447d-994d-052d44bae139',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4831,
      y: 779,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e535bb36-5137-434e-9ff9-d0b8a0be2410',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4089,
      y: 596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '7d1c83aa-37a2-4ca6-843c-743fe37f19fc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4019,
      y: 793,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '8a746b99-e143-4868-9cd5-1be5a36abc35',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4119,
      y: 715,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_4',
      parent: '185',
      data: ''
    },
    {
      id: '20f31596-81e8-4c3c-91bb-ad1579a46f8a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5529,
      y: 536,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '9173ca7b-2ab8-4de2-9d57-8fbb9ff6f9df',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5612,
      y: 550,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '93b2b1f2-00b9-43c5-bf63-2e55b05120b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5699,
      y: 567,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '43537be8-6475-41c6-b8f2-7617b8103d89',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5775,
      y: 606,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'f40f2d37-eef8-4257-8b5e-eef61b8783df',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5858,
      y: 639,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '2dbce353-d6b9-40b5-b282-2b1ee0f7af54',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6002,
      y: 41,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'b7ab0ed1-182e-4ed0-a976-353ec014688a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6042,
      y: 109,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '674fd647-f8ea-4114-bc3d-3590edb36376',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5932,
      y: 124,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'cc2749f6-1f92-4258-af25-c943a56aea36',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5991,
      y: 205,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '7ef819ff-7fea-4375-8ced-46d54b0389e3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6110,
      y: 182,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'c97845ed-8165-4ec7-a84e-309bf80b342d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6101,
      y: 278,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '5a8ca3ed-ed25-4ea0-a297-636cef18f41a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6303,
      y: 282,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'e60b3812-b6a1-48c9-a05f-bf064e287330',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6192,
      y: 310,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '3350a9a8-4851-4da3-b075-c25382243a8d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6240,
      y: 199,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '52779ae7-e108-4836-a401-fe9c08bec44d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6367,
      y: 205,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '6e9df0c8-ffce-4fc5-8bf8-86e3be178ada',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6495,
      y: 207,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '115ce766-49a9-467a-ac8e-1b968ed59745',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6627,
      y: 211,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '1ef74c2f-20ef-4ae3-83c7-bfde94db9a7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6743,
      y: 212,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '91042ca5-a2b6-4942-8c81-3566cd0e3bf9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6553,
      y: 282,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '932b0a57-e269-4a03-b5f1-21a22b8a81ad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6418,
      y: 294,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'd9fa8d3f-7c36-4c21-82c9-d8e9a6cf0a6c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6176,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '609e13e7-df04-4f96-a585-1a808e296eb1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6301,
      y: 120,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'ea7616e7-8a0a-4a84-bedd-0fd2c2374a63',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6424,
      y: 122,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '01f9025c-6cad-46e5-a0fa-dd598e69260d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6551,
      y: 128,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'b5888ea6-e276-4701-ab27-bfae2d618a92',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6680,
      y: 129,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '3185cd97-d28d-46e3-98e7-0567475b39a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6797,
      y: 138,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'b500fccf-daa0-4ea5-b2f0-258e554e92ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6921,
      y: 127,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'f423df96-47ac-4bf6-aa05-6f32d0c68fe4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6122,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'f4ade4dc-6dc0-4e77-bf4b-fd04b1f94458',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6236,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '8a55055b-efd6-48df-ae59-2ca17e16baf6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6352,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'e5b11c29-72c6-4232-9c0b-b9dd26d745af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6485,
      y: 49,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'cecb02ed-4fa5-43af-9e0b-a3f9fa522d90',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6609,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '35d4cc4d-5204-4222-9295-8b77118de2b5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6859,
      y: 54,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '79b29d5b-b197-4d31-b184-26e4f7cddbb2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6729,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '31f4c2e0-2273-4015-9abc-5593eee54969',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6997,
      y: 50,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '23d83249-c54e-4200-9a6c-8b7d9542e996',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5933,
      y: 681,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'fda98a69-20a0-461a-9f59-3f0b3738aef5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6024,
      y: 719,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '0f7b2f7c-b44a-42e0-8d27-173320abcb01',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6123,
      y: 750,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '8f42ff96-42d3-4ad9-84c6-6b680222eaff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5438,
      y: 575,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '5cafbe5e-363b-4ea4-83d5-9efa185d9f6b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5532,
      y: 614,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '6eb90514-56f9-4c56-b3cf-390298191315',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5633,
      y: 635,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '67b3b9cb-25fc-468a-ab47-acd89c0f15d4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5725,
      y: 683,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'bfbfcda4-d1d4-4197-99f2-0695d32eb1d3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5824,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '9a173c21-6d9e-4523-86e2-02f80cf1061f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5923,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'a041bda7-ba6c-4d2b-888a-0a15d2e582a2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6034,
      y: 810,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'a20b9216-8050-497e-9e3e-3a0ee3484e8e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5397,
      y: 636,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '0f507541-0bc2-4e0f-ba58-1b0022378b36',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5846,
      y: 810,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'ca00bcec-9f48-4a7f-a731-f48dba33a1f7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5302,
      y: 674,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '64d9ebed-14d1-4822-8f34-f93ba365a5e5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5421,
      y: 720,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '3a8a0755-493d-44f9-a550-c3234a46163e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5547,
      y: 738,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '5b04112e-0c6d-4d04-b638-83c91b77bb68',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5472,
      y: 800,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '00a8c8ee-a5f7-42d2-8ff3-60668b024670',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5631,
      y: 808,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: 'ded3f3dd-54a5-4786-9e22-6c6679d4d85d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5346,
      y: 777,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '5a7e78df-3681-49f9-91c7-1d7d24603b04',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5237,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '38429cc3-1859-4480-8a33-a26385e17a60',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5494,
      y: 675,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '0f8a3e59-6af3-4710-bb64-0229eb6bc553',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5631,
      y: 710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '8c2e3c13-0d4c-4105-a054-6ebf607d624d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5719,
      y: 757,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '214',
      data: ''
    },
    {
      id: '40968e96-cfc5-4776-81a7-d20a2c481eaf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6611,
      y: 758,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'bc16db76-e5c2-4108-a1b1-9039a46aeb79',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6695,
      y: 703,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '5e3518bc-7098-444e-b46d-1414c7f5cdfa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6785,
      y: 640,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '2e15701f-9a85-4611-8b44-fd9ed7f4431b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6873,
      y: 580,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '5233eae0-ee40-40f2-b289-26057a627272',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6961,
      y: 530,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '2a17b843-6fa1-4c2f-ba16-9be10f8e0035',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7046,
      y: 493,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'b04b0c83-79b1-47fb-9ffa-89ae2edb05ff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6803,
      y: 795,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '94f0385e-3245-40c8-856e-bcc4c056b151',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6892,
      y: 736,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '34474ff8-9152-4f7d-b93e-bb939011d125',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6973,
      y: 681,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'c2dd7cdf-f5fb-4fd7-971d-f491236faf76',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7058,
      y: 627,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'f4fcb1d9-47ec-4045-a5c5-9bfc426778b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7147,
      y: 573,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '48cbc166-9bb4-4a1c-908d-84279e0d1455',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7231,
      y: 527,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'e77126a9-8484-445f-8c90-4586da84d040',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7027,
      y: 782,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'c9393846-c767-4422-bf9a-79dc9beec420',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7105,
      y: 738,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '7e56e221-0c2b-49ef-9099-9630bab62180',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7182,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'f23ea9b4-d660-445e-8654-223d8bcb6a83',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7258,
      y: 647,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'fdacc2e5-6007-4d04-b89c-a65b670baf33',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7336,
      y: 597,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '53736c82-26cb-42f7-b554-00da6c7dbfa0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7300,
      y: 766,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '9ba3da1a-7a59-494d-9bc2-801a817002ec',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7377,
      y: 726,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'f67496e1-b189-4a1b-8304-6a0deb4ee417',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7458,
      y: 820,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '23904219-3153-4607-8880-ff70c5dce94c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7536,
      y: 748,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '16caa3dc-6c73-41c3-bc15-0dcdd3f53031',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7445,
      y: 678,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'caef93ce-5264-4ed0-9088-a68ffc317f22',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7136,
      y: 462,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'f0e2162c-66f5-4818-aebd-771a6b457c8d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7367,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '2c6c2fbc-8dff-486a-adc8-8a31cd0403c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7428,
      y: 68,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '489e06af-ef16-4021-b39a-27dd95f37838',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7499,
      y: 112,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '7a8eda58-5a4e-4ffe-88bc-8bd1448ac1c7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7569,
      y: 162,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'a8232d78-1454-4245-807d-ba5b33d32969',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7640,
      y: 199,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '881ef0f2-a615-48b8-95c4-23c63fa27ba6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7704,
      y: 244,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'da85feed-4565-4672-82cf-94ef8ccceb0a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7770,
      y: 290,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'caceee53-877f-4e19-a828-f2ef8bf70bb4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7838,
      y: 332,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'da152d47-b0f9-4246-8e9a-c903c0c57850',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7909,
      y: 368,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '3a6f93e8-2438-4f99-92f7-8b960e010887',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7594,
      y: 49,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '063f7aa5-5d6c-4cd3-814d-1577185d5496',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7671,
      y: 81,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'dc46a4d4-2a88-431b-bd71-208fde8ceef9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7746,
      y: 116,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'd782a777-e057-4869-bdfe-9ac2137eafda',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7812,
      y: 158,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '8fdb2758-3d71-4856-ad66-96c8649956de',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7883,
      y: 199,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'a9d183eb-5d3f-4965-8803-b6e85d2fe62e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7947,
      y: 236,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '5ebd0e40-d065-4342-aad0-f3721f85d77f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8007,
      y: 276,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'f4236c81-6105-47be-bf22-ecfa56cb8c37',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8064,
      y: 315,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'a03c1769-34bf-4fad-924a-1ad473edbd31',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7816,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '154740bc-ae3b-4bc4-a337-aed1eb641755',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7882,
      y: 59,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '62a3fea7-b309-4db8-8aa7-e1510f8f3591',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7960,
      y: 100,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'c8012557-500f-4aa0-ae66-9fc6ad9b3fbd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8030,
      y: 147,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '4b5ef509-59f0-4c20-b18e-c2af3c8c8f6b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8097,
      y: 182,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '2fdf6a21-019a-494e-b36a-410f087d3ad4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8163,
      y: 228,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '08eec2f2-88dd-47f2-9f91-8fe32685e27e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8090,
      y: 50,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'e2713605-247a-4536-ad23-b348f8d2f640',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8158,
      y: 92,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'e82bda6d-a008-464e-8f4d-2f85dd061789',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8225,
      y: 130,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'a42cc695-0c61-40a0-9dcd-459d52d780cb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8284,
      y: 170,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'eac76dab-e19c-424a-9137-86dff2c0b398',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8269,
      y: 41,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: 'b12f1e53-5315-474f-946d-b2073a94e03e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8339,
      y: 83,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_4',
      parent: '219',
      data: ''
    },
    {
      id: '6593f497-0c6d-4c53-966a-6983f903d06d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7929,
      y: 802,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'ef8345be-16a1-41b6-9029-8cdb51bea97e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8033,
      y: 754,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'b9a35673-4db3-489e-93a3-6c104b864918',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8136,
      y: 705,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '8defe3b9-79be-4209-bdae-29823d90916f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8228,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd8698f78-3083-487e-8f2d-7cc3af669947',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8318,
      y: 618,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '415b9245-dd8d-4050-894c-16e3077392ff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8143,
      y: 847,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '54c0244b-45ac-4c67-a158-c416922b8a2d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8244,
      y: 806,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '86c278c9-40ef-42fa-846d-5449c91c2e32',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8337,
      y: 752,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e8609885-aac6-44a8-bb61-4147fa91750f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8421,
      y: 707,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '6672f069-7429-4994-8711-61b811392889',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8465,
      y: 835,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c4e16138-835c-4170-8d42-e6861cd99835',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8757,
      y: 676,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f611d1f7-b65c-41c6-91bb-560f6dcef86c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8870,
      y: 763,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '764afad5-bc66-4f5a-8a79-c6a9f89d53b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8968,
      y: 801,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '448cd0e8-e968-41a0-9c4d-a03c6007073e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8878,
      y: 627,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd9dfed34-b868-41f0-b13d-36e9ce44fc4f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8970,
      y: 669,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f357fc54-e457-4feb-9b2a-f31927fb6712',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9062,
      y: 710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '119521f5-5ed4-47a8-ab08-015a73c497a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9151,
      y: 754,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '09f58a32-ac0c-4f2e-806c-ec4a91e1b492',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9252,
      y: 824,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c66df87f-256b-48b5-9bcf-79699b46ef8d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8905,
      y: 147,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'ffadb7a7-3a2d-4e05-8725-8b2127687645',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8976,
      y: 58,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '8f532357-2561-49a2-a453-6c7337e21b7c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8972,
      y: 264,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f3bd2234-d45d-4b84-80e5-9af80518613a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9037,
      y: 179,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'b6e4d43b-56d5-4480-b5f6-2862c3c78533',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9109,
      y: 96,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '93074364-6dfe-4d55-a1ad-3b6fa204efc9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9174,
      y: 35,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '797484e6-e716-4c0f-a866-9efaa2325b05',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9100,
      y: 327,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '0aebe19b-7ca1-46f2-9c03-b7720246385d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9171,
      y: 243,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '22a5d7fe-76eb-446c-8d8f-1cf146c79464',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9228,
      y: 165,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '7c828758-f729-4ae7-b571-56e4740c0cb2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9293,
      y: 93,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'bc8ca25b-5317-44f0-80b9-1509f5da2c01',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9349,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f5b5ee0c-b9bb-436b-a305-eaaf4e81401b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9268,
      y: 358,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c099ed16-1eed-4abd-8963-6f4d010f8583',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9340,
      y: 286,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '90513aae-61d4-4a13-ae75-8c7cc623a342',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9400,
      y: 212,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'ee4000c5-50ba-4a5e-b90c-623b1a33e160',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9461,
      y: 145,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '228ea341-c24b-4a07-944b-275e74793a8a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8778,
      y: 830,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: 'db4b6096-ccb7-45ca-aab4-9fe903775855',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9073,
      y: 852,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '224',
      data: ''
    },
    {
      id: '339e0db6-7aa5-41cd-9ba1-b73417e0bb33',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9820,
      y: 60,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '8b18df0d-5f66-44d5-b884-710fec9c2608',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9909,
      y: 87,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '59a51ac0-553d-4227-be47-b16c01558fcd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10004,
      y: 114,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'ff25e7e0-2ad4-4b1b-aeb0-ceb1346f9db7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10096,
      y: 144,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2366da7c-2950-4b45-b05a-37ae3693d3b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10178,
      y: 177,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'f9720654-ff1e-43c3-857e-63baad365d0f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10130,
      y: 26,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'df0f5a00-7716-459a-bfea-0b4c4a411dbe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10224,
      y: 55,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'e1c8d3b1-ed74-44a9-8876-9c0f2b72a465',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10309,
      y: 89,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '81adc6c6-afb6-4a16-bb52-fffbebdf9846',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9529,
      y: 761,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'ecc3bf7a-deb1-4243-a4e6-cfd9da9197c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9631,
      y: 740,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '9cd528dc-8d3f-491a-94dc-d1be2e604bfc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9727,
      y: 716,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'a0c9702a-8c80-4a76-9cd6-c2abe98f927d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9819,
      y: 705,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'a8014c4c-0329-4fac-ae2a-18006cbe42a5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9924,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'fda46310-d870-4214-999f-7c818de9841d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10019,
      y: 690,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'cfba936e-ac15-4cef-abea-a32afb183fd1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10121,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'e2864efd-e298-459f-92f5-dfb112cef214',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9682,
      y: 843,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '17a388ec-c027-4444-b5e2-f87e9d70571a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9785,
      y: 822,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '5c28d1f0-9134-4506-bd25-227c4321fac9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9895,
      y: 805,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '4ba80000-7ce6-4459-8725-0c388f6e43e7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10003,
      y: 796,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'ed2a3a06-2c2d-47b1-bdef-b2eb5dcd4f02',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10108,
      y: 792,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '0d0566eb-c5dd-46b8-93b4-f86ddbd9c74e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10207,
      y: 789,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 966,
      y: 167,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '106',
      data: ''
    },
    {
      id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1612,
      y: 655,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '160',
      data: ''
    },
    {
      id: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3457,
      y: 212,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '181',
      data: ''
    },
    {
      id: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4362,
      y: 579,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '210',
      data: ''
    },
    {
      id: '107',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6231,
      y: 229,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '215',
      data: ''
    },
    {
      id: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7256,
      y: 618,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '220',
      data: ''
    },
    {
      id: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8801,
      y: 605,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '225',
      data: ''
    },
    {
      id: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9861,
      y: 655,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '230',
      data: ''
    },
    {
      id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '85746295-e987-4e2b-a7d0-6791216b55a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_harvest_map',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '656a5808-34d6-4751-a733-6af98d163ac6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'yellowazalea_harvest_map',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: 'c001f4bb-2f73-4bf8-8953-deb543c31f21',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      data: ''
    },
    {
      id: 'c41c933b-373f-4a3d-bdc7-f748ce87c274',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_harvest_map',
      parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      data: ''
    },
    {
      id: '16ac1fb4-d061-449e-87ad-02f0d5dff6e9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      data: ''
    },
    {
      id: '958851db-006d-425c-afff-a85018a3cb2b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'redclover_harvest_map',
      parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      data: ''
    },
    {
      id: '108',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '107',
      data: ''
    },
    {
      id: '109',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_harvest_map',
      parent: '107',
      data: ''
    },
    {
      id: '46aeb65d-4896-4557-9865-75ef0057e163',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      data: ''
    },
    {
      id: 'ac0db26e-8010-4059-87b0-18b44d3c25ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ladyorchid_harvest_map',
      parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      data: ''
    },
    {
      id: '03074616-c479-4d19-9e8c-855582627513',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      data: ''
    },
    {
      id: '018bb44b-6ca0-491c-b479-368ca2fa6897',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_harvest_map',
      parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      data: ''
    },
    {
      id: '2e08b7f7-57a1-4e7c-baf5-459d9f88afdd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      data: ''
    },
    {
      id: 'c077834a-7855-43ec-a465-2f5ed5df5421',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'lily_harvest_map',
      parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class WorldLayout25 {
  static raw = raw;
  root: PIXI.Container
  backgrounds: PIXI.Container
  nodesContainer: PIXI.Container
  cropsSectorA: (PIXI.Container)[]
  cropsSectorB: (PIXI.Container)[]
  signsSectorA: (PIXI.Container)[]
  signsSectorB: (PIXI.Container)[]

  constructor() {
    populate(this, raw);
  }
}
